import { ItemType } from './abstract-item-model';
import { GenericItem } from './generic-item-model';

const moment = require('moment');

export class ProductItem extends GenericItem {
  public type: string = ItemType.Product.toString();

  public brandMake: string;
  public model: string;

  public makeDummy(): ProductItem {
    this.imageURL = 'https://images-na.ssl-images-amazon.com/images/I/81C0IbOHHpL._SX425_.jpg';
    this.brandMake = 'Såk Gear';
    this.model = 'BackSåk Waterproof Backpack';
    this.url = 'https://www.amazon.com/Backpack-Business-Charging-Resistant-Computer/dp/B06XZTZ7GB/ref=sr_1_2_sspa?keywords=backpack&amp;qid=1561064390&amp;s=gateway&amp;sr=8-2-spons&amp;psc=1';
    this.subtitle = 'subtitle?';
    this.timeAdded = moment().startOf('hour');
    return this;
  }

  public toFirebaseDoc(): any {
    const doc = super.toFirebaseDoc();
    doc.type = ItemType.Product.toString();
    doc.brandMake = this.brandMake || null;
    doc.model = this.model || null;
    doc.title = this.brandMake + ' ' + this.model;
    return doc;
  }

  public fromFirebaseDoc(id: string, document: any): ProductItem {
    super.fromFirebaseDoc(id, document);
    this.brandMake = document.brandMake as string;
    this.model = document.model as string;
    return this;
  }
}
